import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/i18n";

import ScrollToTop from "@/components/ScrollToTop";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Restaurant from "@/pages/Restaurant";
import Menu from "@/pages/Menu";
import Gallery from "@/pages/Gallery";
import Reservation from "@/pages/Reservation";
import Events from "@/pages/Events";
import Reviews from "@/pages/Reviews";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import LocalSeo from "@/pages/LocalSeo";
import { BlogList, BlogArticle } from "@/pages/Blog";

import { AuthProvider } from "@/contexts/AuthContext";
import { SettingsProvider } from "@/contexts/SettingsContext";

import AdminLogin from "@/pages/admin/Login";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import AdminReservations from "@/pages/admin/Reservations";
import { AdminEvents, AdminContact } from "@/pages/admin/EventsContact";
import AdminMenu from "@/pages/admin/MenuAdmin";
import { AdminReviews, AdminBlog, AdminGallery } from "@/pages/admin/Content";
import AdminSettings from "@/pages/admin/Settings";

function App() {
  return (
    <SettingsProvider>
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            {/* Public site */}
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/restaurant" element={<Restaurant />} />
              <Route path="/menu" element={<Menu />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/reservation" element={<Reservation />} />
              <Route path="/events" element={<Events />} />
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/blog" element={<BlogList />} />
              <Route path="/blog/:slug" element={<BlogArticle />} />
              <Route path="/restaurant-mulhouse" element={<LocalSeo />} />
              <Route path="/restaurant-francais-mulhouse-haut-rhin" element={<LocalSeo />} />
              <Route path="/legal/:slug" element={<Legal />} />
            </Route>

            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="menu" element={<AdminMenu />} />
              <Route path="reservations" element={<AdminReservations />} />
              <Route path="events" element={<AdminEvents />} />
              <Route path="contact" element={<AdminContact />} />
              <Route path="reviews" element={<AdminReviews />} />
              <Route path="blog" element={<AdminBlog />} />
              <Route path="gallery" element={<AdminGallery />} />
              <Route path="settings" element={<AdminSettings />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </SettingsProvider>
  );
}

export default App;
